import {
  ICON_AIRPLANE_ACTIVE,
  ICON_AIRPLANE_INACTIVE,
  ICON_CRUISE_ACTIVE,
  ICON_CRUISE_INACTIVE,
  ICON_RADIO,
  ICON_RADIO_ACTIVE,
} from '@repo/assets';
import { Icon } from '@successmode-ktp/kui';
import styled from 'styled-components';

type Props = {
  selectedAirport: string;
  onSelect: (airport: string) => void;
  nationality: string;
};

export const AirportSelection = ({
  selectedAirport,
  onSelect,
  nationality,
}: Props) => {
  const nation = nationality === 'KOR' ? 'KOR' : 'ENG';

  const text = {
    KOR: {
      title: '출국장을 선택해주세요',
      description: '출국장소를 선택해주세요.',
    },
    ENG: {
      title: 'Select Departure location',
      description: 'Please select your Departure location',
    },
  };

  return (
    <>
      <Header>
        <Icon.Departure size={36} fillColor='#3a3b3e' />
        <Title>{text[nation].title}</Title>
      </Header>
      <Description>{text[nation].description}</Description>
      <SelectList>
        <SelectWrapper
          isActive={selectedAirport === 'Incheon Airport'}
          onClick={() => onSelect('Incheon Airport')}
        >
          <TitleWrapper>
            <img
              src={
                selectedAirport === 'Incheon Airport'
                  ? ICON_RADIO_ACTIVE
                  : ICON_RADIO
              }
              alt=''
              width={24}
            />
            {nationality === 'KOR' ? '주요공항' : 'Major Airports'}
            <AirportImg
              src={
                selectedAirport === 'Incheon Airport'
                  ? ICON_AIRPLANE_ACTIVE
                  : ICON_AIRPLANE_INACTIVE
              }
              alt=''
            />
          </TitleWrapper>
          <AirportList>
            <AirportItem isActive={selectedAirport === 'Incheon Airport'}>
              {nationality === 'KOR' ? '인천' : 'Incheon Airport'}
            </AirportItem>
            <AirportItem isActive={selectedAirport === 'Incheon Airport'}>
              {nationality === 'KOR' ? '김포' : 'Gimpo Airport'}
            </AirportItem>
            <AirportItem isActive={selectedAirport === 'Incheon Airport'}>
              {nationality === 'KOR' ? '김해' : 'Gimhae Airport'}
            </AirportItem>
            <AirportItem isActive={selectedAirport === 'Incheon Airport'}>
              {nationality === 'KOR' ? '제주' : 'Jeju Airport'}
            </AirportItem>
          </AirportList>
        </SelectWrapper>
        <SelectWrapper
          isActive={selectedAirport === 'ETC'}
          onClick={() => onSelect('ETC')}
        >
          <TitleWrapper>
            <img
              src={selectedAirport === 'ETC' ? ICON_RADIO_ACTIVE : ICON_RADIO}
              alt=''
              width={24}
            />
            {nationality === 'KOR' ? '그 외 공항' : 'Other Airports'}
            <AirportImg
              src={
                selectedAirport === 'ETC'
                  ? ICON_AIRPLANE_ACTIVE
                  : ICON_AIRPLANE_INACTIVE
              }
              alt=''
            />
          </TitleWrapper>
        </SelectWrapper>
        <SelectWrapper
          isActive={selectedAirport === 'Cruise'}
          onClick={() => onSelect('Cruise')}
        >
          <TitleWrapper>
            <img
              src={
                selectedAirport === 'Cruise' ? ICON_RADIO_ACTIVE : ICON_RADIO
              }
              alt=''
              width={24}
            />
            {nationality === 'KOR' ? '크루즈' : 'Cruise [Ship]'}
            <AirportImg
              src={
                selectedAirport === 'Cruise'
                  ? ICON_CRUISE_ACTIVE
                  : ICON_CRUISE_INACTIVE
              }
              alt=''
            />
          </TitleWrapper>
        </SelectWrapper>
      </SelectList>
    </>
  );
};

const Header = styled.header`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  margin-top: 24px;
  margin-bottom: 4px;
`;

const Title = styled.h2`
  color: #3a3b3e;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
`;

const Description = styled.p`
  width: 100%;
  color: #80848a;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 42px;
`;

const SelectList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 42px;
`;

const SelectWrapper = styled.button<{ isActive?: boolean }>`
  width: 100%;
  padding: 16px 20px 20px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
  color: ${({ isActive }) => (isActive ? '#246CF6' : '#949494')};
  font-size: 18px;
  font-weight: 500;
  letter-spacing: -0.36px;
  line-height: 140%;
  border: 1px solid
    ${({ isActive = false }) => (isActive ? '#246CF6' : '#E5E6E8')};
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const AirportItem = styled.li<{ isActive?: boolean }>`
  border-radius: 6px;
  background: ${({ isActive }) => (isActive ? '#E9F0FE' : '#f5f6f7')};
  color: ${({ isActive }) => (isActive ? '#5089F8' : '#949494')};
  font-size: 14px;
  font-weight: 500;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
  padding: 3.5px 8px;
  white-space: nowrap;
`;

const AirportImg = styled.img`
  width: 36px;
  height: 36px;
  margin-left: auto;
`;

const AirportList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-left: 36px;
`;
